import { render, staticRenderFns } from "./ChooseDeliveryMode.vue?vue&type=template&id=487cb58e"
import script from "./ChooseDeliveryMode.vue?vue&type=script&lang=js"
export * from "./ChooseDeliveryMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports